/* eslint-disable no-unused-vars */
import Vue from "vue";

import {
  getDatabase,
  ref,
  get,
  set,
  update,
  remove,
  push,
  query,
  child,
  orderByChild,
  limitToLast,
  limitToFirst,
  equalTo,
  onValue,
  onChildAdded,
  onChildRemoved,
  runTransaction,
  serverTimestamp,
  onChildChanged,
} from "firebase/database";

import {
  SHOW_CONFIRM_DIALOG,
  CHANGE_EXPAND_MENU,
  FETCH_NOTIFICATIONS,
  REMOVE_NOTIFICATION,
  READ_NOTIFICATION,
  GET_UNREAD_NOTIFICATION,
  GET_TOPIC_BY_ID,
  GET_MEMBER_BY_ID,
  GET_COMMENT_BY_ID,
  GET_SUBCOMMENT_BY_ID,
  VIEW_USER_PROFILE,
} from "../actions";

import {
  SET_CONFIRM_DIALOG,
  SET_EXPAND_MENU,
  SET_NOTIFICATION_EVENT,
  DEL_NOTIFICATION_EVENT,
  SET_UNREAD_COUNT,
  SET_RECENT_NOTIFICATION,
  SET_USER_TO_VIEW,
} from "../mutations";

const database = getDatabase();

const state = {
  confirmDialog: null,
  expandMenu: { expand: false },
  notifications: { unreadCount: 0, recent: null, events: {} },
  profile: { userId: "", view: false },
};

const getters = {
  confirmDialog({ confirmDialog }) {
    return confirmDialog;
  },
  expandMenu({ expandMenu }) {
    return expandMenu;
  },
  notifications({ notifications }) {
    return notifications;
  },
  profile({ profile }) {
    return profile;
  },
};

const mutations = {
  [SET_CONFIRM_DIALOG](state, value) {
    state.confirmDialog = value;
  },
  [SET_EXPAND_MENU](state, value) {
    state.expandMenu = value;
  },
  [SET_NOTIFICATION_EVENT](state, { key, ...others }) {
    Vue.set(state.notifications.events, key, { ...others });
  },
  [DEL_NOTIFICATION_EVENT](state, { id }) {
    Vue.delete(state.notifications, id);
  },
  [SET_UNREAD_COUNT](state, value) {
    state.notifications.unreadCount = value;
  },
  [SET_RECENT_NOTIFICATION](state, value) {
    state.notifications.recent = value;
  },
  [SET_USER_TO_VIEW](state, value) {
    state.profile = value;
  },
};

const actions = {
  [SHOW_CONFIRM_DIALOG]({ commit }, payload) {
    commit(SET_CONFIRM_DIALOG, payload);
  },
  [CHANGE_EXPAND_MENU]({ commit }, payload) {
    commit(SET_EXPAND_MENU, payload);
  },
  [GET_UNREAD_NOTIFICATION]({ rootGetters, commit }) {
    const { uid } = rootGetters["auth/currentUser"];
    const unreadRef = query(ref(database, `members/${uid}/notifications/unreadCount`));

    onValue(unreadRef, async (data) => {
      const recentRef = query(ref(database, `members/${uid}/notifications/events`), orderByChild("createdAt"), limitToLast(1));
      const snpRecent = await get(recentRef);
      if (snpRecent.val()) {
        const recentNotification = Object.entries(snpRecent.val());
        const recentData = { notificationId: recentNotification[0][0], ...recentNotification[0][1] };
        commit(SET_RECENT_NOTIFICATION, recentData);
        commit(SET_UNREAD_COUNT, data.val());
      }
    });
  },
  async [READ_NOTIFICATION]({ rootGetters, state, commit }, payload) {
    const { uid } = rootGetters["auth/currentUser"];
    const { notificationId, oldCreatedAt } = payload;
    const createdAt = serverTimestamp();
    await update(ref(database, `members/${uid}/notifications/events/${notificationId}`), {
      isRead: true,
      createdAt,
      oldCreatedAt,
    });
    await runTransaction(ref(database, `members/${uid}/notifications/unreadCount`), (unreadCount) => {
      if (unreadCount) {
        unreadCount--;
      } else {
        unreadCount = 0;
      }
      return unreadCount;
    });
  },
  [FETCH_NOTIFICATIONS]({ rootGetters, state, commit, dispatch }) {
    const { uid } = rootGetters["auth/currentUser"];
    const notificationsRef = query(ref(database, `members/${uid}/notifications/events`), orderByChild("createdAt", "desc"));

    onChildAdded(notificationsRef, async (data) => {
      const result = data.val();
      const notificationId = data.key;

      let eventData;
      const eventUser = await dispatch(`community/${GET_MEMBER_BY_ID}`, { uid: result.uid }, { root: true });

      switch (result.event) {
        case "topic":
          eventData = await dispatch(`community/${GET_TOPIC_BY_ID}`, { topicId: result.id }, { root: true });
          break;
        case "comment":
          eventData = await dispatch(`community/${GET_COMMENT_BY_ID}`, { commentId: result.id }, { root: true });
          break;
        case "subcomment":
          eventData = await dispatch(`community/${GET_SUBCOMMENT_BY_ID}`, { subCommentId: result.id }, { root: true });
          break;
        default:
          break;
      }
      commit(SET_NOTIFICATION_EVENT, { key: notificationId, notificationId, ...result, user: eventUser, eventData });
    });
  },
  [REMOVE_NOTIFICATION]({ commit }, payload) {
    commit(DEL_NOTIFICATION_EVENT, { id: payload });
  },

  [VIEW_USER_PROFILE]({ commit }, payload) {
    commit(SET_USER_TO_VIEW, payload);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
